var util = (function(window, document) {
  /*"use strict"; */ // Start of use strict

  var module = {};

  module.id = function(selector) {
    return document.getElementById(selector);
  };

  module.outputMsg = function(element, message) {
    element.innerHTML += message;
  };

  module.isEmptyObj = function() {
    for (var key in this) {
      if (this.hasOwnProperty(key)) {
        return false;
      }
    }

    return true;
  };

  return module;
})(window, document);